var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Gallery,{staticClass:"custom-malling-gallery",attrs:{"photo-swipe":false,"duration":7000,"data":{ images: _setup.props.images }}})
}
var staticRenderFns = []

export { render, staticRenderFns }